import React, { useMemo, useState } from 'react';
import Logo from '@/assets/image/vip/logo.png';
import LogoWeb from '@/assets/image/vip/logo-web.png';
import LogoSingle from '@/assets/image/vip/logo-single.png';
import { getIncomeSource, getVipTag, isAppStorePay, isWeb } from '@/utils/vip';
import { getUrlParam } from '@/utils';
import { SubscribeType, isTeamSubscription, subscribeType } from '@/constants';
import classnames from 'classnames';
import ConsultationModal from '@/components/consultation-modal';
import { TabType } from '@/constants/subscription';
import { openVipComparePopup } from '@meitu/saas-subscription-popup/dist/esm/utils';
import { useAtom } from 'jotai';
import { curProductAtom, curTabAtom, userInfoAtom, vipInfoAtom } from '@/store';
import { track } from '@/utils/common';
import { getJumpQuery } from '@/utils/jumpQuery';
import MaterialVip from '@/assets/image/new/material-vip.png';
import MaterialPro from '@/assets/image/new/material-pro.png';
import MaterialMeidou from '@/assets/image/new/material-meidou.png';
import MaterialTeamVip from '@/assets/image/new/material-team-vip.png';
import MaterialCutout from '@/assets/image/new/material-cutout.png';
import MaterialBatch from '@/assets/image/new/material-cutout.png';

import styles from './index.module.css';

const Copywriting = () => {
  const [visible, setVisible] = useState<boolean>(false);
  const type = getUrlParam('type');

  const [curTab] = useAtom(curTabAtom);
  const [userInfo] = useAtom(userInfoAtom);
  const [vipInfo] = useAtom(vipInfoAtom);
  const [curProduct] = useAtom(curProductAtom);

  const materialUrl = useMemo(() => {
    // 内嵌批处理
    if (type === 'svip') {
      return MaterialBatch;
    }

    let url = null;
    switch (curTab) {
      case TabType.SUB:
        url = isTeamSubscription ? MaterialTeamVip : MaterialVip;
        break;
      case TabType.PRO_SUB:
        url = MaterialPro;
        break;
      case TabType.MEIDOU:
        url = MaterialMeidou;
        break;
      case TabType.CUTOUT:
        url = MaterialCutout;
        break;
      default:
        return MaterialVip;
    }
    return url;
  }, [curTab, isTeamSubscription, type]);

  const handleClick = () => {
    setVisible(true);
    track({
      event_id: 'vip_page_click',
      event_name: '会员落地页点击',
      params: {
        class: 'service',
      },
    });
  };

  return (
    <div className={classnames(styles.module)}>
      <div className={styles.materialBox}>
        <img className={styles.materialImg} src={materialUrl} alt="" />
        {isTeamSubscription && curTab === TabType.SUB ? (
          <div
            className={styles.btn}
            onClick={() => {
              const jumpQuery = getJumpQuery();
              openVipComparePopup();
              const params = {
                class: 'view',
                name_id: curProduct?.productId,
                ...jumpQuery,
              };
              track({
                event_id: 'vip_page_click',
                event_name: '会员落地页点击',
                params,
              });
            }}
          >
            {'查看详细权益 >'}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default React.memo(Copywriting);
